import { createContext } from "react";

export interface IAppointmentDataContext {}

const defaultAppointmentContext: IAppointmentDataContext = {};

export const AppointmentDataContext = createContext<IAppointmentDataContext>(
   defaultAppointmentContext,
);
